import { fetchAuthSession } from "aws-amplify/auth";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";

export async function clearDeveloperBrowserSession() {
  await cognitoUserPoolsTokenProvider.authTokenStore.clearTokens();
}

export async function getDeveloperRelayAuthState() {
  const session = await fetchAuthSession();
  const storedTokens =
    await cognitoUserPoolsTokenProvider.authTokenStore.loadTokens();
  const idToken = session.tokens?.idToken;
  const accessToken = session.tokens?.accessToken;
  const refreshToken = storedTokens?.refreshToken;

  if (!idToken || !accessToken || !refreshToken) {
    throw new Error("The developer session is incomplete.");
  }

  return {
    idToken: idToken.toString(),
    accessToken: accessToken.toString(),
    refreshToken,
  };
}
